import { render, staticRenderFns } from "./AddView.vue?vue&type=template&id=d8357682&scoped=true"
import script from "./AddView.vue?vue&type=script&lang=ts"
export * from "./AddView.vue?vue&type=script&lang=ts"
import style0 from "./AddView.vue?vue&type=style&index=0&id=d8357682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8357682",
  null
  
)

export default component.exports